import radiusOptions from './radius-options.esm.js';

var radiusOptionList = Object.keys(radiusOptions.radius);
var radiusBottomOptionList = Object.keys(radiusOptions.radiusBottom);
var radiusTopOptionList = Object.keys(radiusOptions.radiusTop);
var radiusLeftOptionList = Object.keys(radiusOptions.radiusLeft);
var radiusRightOptionList = Object.keys(radiusOptions.radiusRight);

export { radiusBottomOptionList, radiusLeftOptionList, radiusOptionList, radiusRightOptionList, radiusTopOptionList };
//# sourceMappingURL=types.esm.js.map
